import { buildLegend } from "@features/sales-v3/utils/tooltip";

export const REVENUE_ID = "Revenue";
export const REVENUE_COLOR = "#5CBF64";
export const REVENUE_LEGEND = buildLegend(
  {
    borderColor: REVENUE_COLOR,
    backgroundColor: REVENUE_COLOR,
    borderDash: [],
  },
  false,
);

export const SPEND_ID = "Spend";
export const SPEND_COLOR = "#7081FF";
export const SPEND_BORDER_DASH = [5, 3];
export const SPEND_LEGEND = buildLegend(
  {
    borderColor: SPEND_COLOR,
    backgroundColor: SPEND_COLOR,
    borderDash: SPEND_BORDER_DASH,
  },
  false,
);

export const ROAS_ID = "ROAS";
export const ROAS_COLOR = "#7081FF";
export const ROAS_LEGEND = buildLegend(
  {
    borderColor: ROAS_COLOR,
    backgroundColor: ROAS_COLOR,
    borderDash: [],
  },
  false,
);

export const PROMO_ID = "PROMO";
export const PROMO_COLOR = "#5CBF64";
export const PROMO_BORDER_DASH = [5, 3];
export const PROMO_LEGEND = buildLegend(
  {
    borderColor: PROMO_COLOR,
    backgroundColor: PROMO_COLOR,
    borderDash: PROMO_BORDER_DASH,
  },
  false,
);

export const TOTAL_KPI_ID = "TOTAL_KPI";
export const TOTAL_KPI_COLOR = "#5CBF64";
export const TOTAL_KPI_BORDER_DASH = [3, 1];
export const TOTAL_KPI_LEGEND = buildLegend(
  {
    borderColor: TOTAL_KPI_COLOR,
    backgroundColor: TOTAL_KPI_COLOR,
    borderDash: TOTAL_KPI_BORDER_DASH,
  },
  false,
);
